import React from 'react';
import { Navigate } from 'react-router-dom';
import HomeView from '../Pages/HomeView/HomeView'; // 首页
import AboutUs from '../Pages/AboutUs/AboutUs'; // 关于我们
import Contact from '../Pages/Contact'; // 联系我们
import SolutionLayout from '../Pages/SolutionLayout/SolutionLayout'; // 行业解决方案 布局
import FinancialLeasingSystem from '../Pages/FinancialLeasingSystem/FinancialLeasingSystem'; // 融资租赁系统
import FactoringSystem from '../Pages/FactoringSystem/FactoringSystem'; // 保理系统
import TradeSystem from '../Pages/TradeSystem/TradeSystem'; // 贸易系统
import SupplyChainFinance from '../Pages/SupplyChainFinance/SupplyChainFinance'; // 供应链金融
import ProductServices from '../Pages/ProductServices/ProductServices'; // 产品服务
import QualificationCertificate from '../Pages/QualificationCertificate/QualificationCertificate'; // 资质证书
import Partners from '../Pages/Partners/Partners'; // 合作伙伴
import IndustryDetailsView from '../Pages/IndustryDetails/IndustryDetails'; // 行业详情
import Disclaimers from '../Pages/Disclaimers/Disclaimers'; // 免责声明
import Trial from '../Pages/Trial/Trial';
const ROUTER_LIST = [
  {
    path: '/',
    element: <Navigate to="/home" />,
    meta: {
      flag: false,
    },
  },
  {
    path: '/home',
    element: <HomeView />,
    meta: {
      title: '首页',
      flag: true,
    },
  },
  {
    path: '/about',
    element: <AboutUs />,
    meta: {
      title: '关于我们',
      flag: true,
    },
  },
  {
    path: '/solution',
    element: <SolutionLayout />,
    meta: {
      title: '行业解决方案',
      flag: true,
    },
    children: [
      {
        index: true,
        path: '/solution',
        element: <Navigate to="/solution/factoring" />,
      },
      {
        path: '/solution/factoring',
        element: <FactoringSystem />,
        meta: {
          title: '保理系统',
          flag: true,
        },
      },
      {
        path: '/solution/trade',
        element: <TradeSystem />,
        meta: {
          title: '贸易系统',
          flag: true,
        },
      },
      {
        path: '/solution/supply',
        element: <SupplyChainFinance />,
        meta: {
          title: '供应链金融',
          flag: true,
        },
      },
      {
        path: '/solution/financial/leasing',
        element: <FinancialLeasingSystem />,
        meta: {
          title: '融资租赁',
          flag: true,
        },
      },
    ],
  },
  {
    path: '/product/services',
    element: <ProductServices />,
    meta: {
      title: '产品服务',
      flag: true,
    },
  },
  {
    path: '/qualification/certificate',
    element: <QualificationCertificate />,
    meta: {
      title: '资质证书',
      flag: true,
    },
  },
  {
    path: '/partners',
    element: <Partners />,
    meta: {
      title: '合作伙伴',
      flag: true,
    },
  },
  {
    path: '/details',
    element: <IndustryDetailsView />,
    meta: {
      title: '新闻详情',
      flag: false,
    },
  },
  {
    path: '/disclaimers',
    element: <Disclaimers />,
    meta: {
      title: '免责声明',
      flag: false,
    },
  },
  {
    path: '/contact',
    element: <Contact />,
    meta: {
      title: '联系我们',
      flag: true,
    },
  },
  {
    path: '/trial',
    element: <Trial />,
    meta: {
      title: '申请试用',
      flag: true,
    },
  },
];

export default ROUTER_LIST;
